import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { IconHome, IconCalendar, IconTicket } from './Icons';

interface BottomNavProps {
  active: 'home' | 'events' | 'my';
}

export default function BottomNav({ active }: BottomNavProps) {
  const items = [
    { id: 'home', path: '/', Icon: IconHome, label: '首頁' },
    { id: 'events', path: '/events', Icon: IconCalendar, label: '活動' },
    { id: 'my', path: '/my-bookings', Icon: IconTicket, label: '我的報名' },
  ] as const;

  return (
    <nav
      aria-label="主選單"
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-line-soft safe-bottom pt-2"
      style={{ transform: 'translateZ(0)' }}
    >
      <div className="grid grid-cols-3">
        {items.map(({ id, path, Icon, label }) => {
          const isActive = active === id;
          return (
            <Link
              key={id}
              to={path}
              aria-current={isActive ? 'page' : undefined}
              className={clsx('flex flex-col items-center gap-1 text-[11px]', isActive ? 'text-ink font-bold' : 'text-muted')}
            >
              <span className={clsx('w-11 h-7 rounded-full inline-flex items-center justify-center', isActive && 'bg-primary-soft text-primary')}>
                <Icon size={20} />
              </span>
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
